import { FiX, FiZap } from "react-icons/fi";

interface WorkoutPlanAIModalHeaderProps {
  readonly onClose: () => void;
  readonly hasResult: boolean;
  readonly titleId: string;
  readonly descriptionId: string;
  readonly visiblePrescriptionsCount: number;
  readonly totalExercises: number;
}

export function WorkoutPlanAIModalHeader({
  onClose,
  hasResult,
  titleId,
  descriptionId,
  visiblePrescriptionsCount,
  totalExercises,
}: WorkoutPlanAIModalHeaderProps) {
  return (
    <div className="relative border-b border-stroke bg-gradient-to-r from-purple-50 via-purple-50 to-purple-50 px-4 sm:px-8 py-4 sm:py-6 dark:border-strokedark dark:from-purple-950/30 dark:via-purple-950/30 dark:to-purple-950/30">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      <button
        type="button"
        onClick={onClose}
        className="absolute right-2 top-2 sm:right-6 sm:top-6 z-10 min-h-[44px] min-w-[44px] rounded-xl p-2 text-gray-500 outline-none transition-all hover:bg-white hover:text-gray-700 hover:shadow-sm focus-visible:ring-2 focus-visible:ring-primary dark:text-gray-400 dark:hover:bg-boxdark dark:hover:text-gray-200"
        aria-label="Fechar modal"
      >
        <FiX size={20} className="sm:w-6 sm:h-6" />
      </button>

      <div className="relative flex items-start gap-3 sm:gap-5 pr-10 sm:pr-0">
        <div className="relative flex-shrink-0">
          <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-purple-600 to-purple-600 opacity-75 blur"></div>
          <div className="relative flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-gradient-to-r from-purple-600 to-purple-700 shadow-xs dark:border-boxdark">
            <FiZap className="text-white w-5 h-5 sm:w-7 sm:h-7" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3
            id={titleId}
            className="text-lg sm:text-2xl font-bold text-gray-900 dark:text-white"
          >
            Criar Treino com Inteligência Artificial
          </h3>
          <p
            id={descriptionId}
            className="mt-1 text-xs sm:text-sm text-gray-600 dark:text-gray-400"
          >
            {hasResult
              ? "Revise e personalize os treinos sugeridos antes de aplicar."
              : "Descreva o treino desejado e a IA criará um plano completo."}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2 text-xs" aria-label="Progresso do fluxo de IA">
            <span
              className={`rounded-full px-3 py-1 font-semibold ${
                !hasResult
                  ? "bg-purple-600 text-white"
                  : "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300"
              }`}
            >
              1. Descrição
            </span>
            <span className="text-gray-500 dark:text-gray-400">{"->"}</span>
            <span
              className={`rounded-full px-3 py-1 font-semibold ${
                hasResult
                  ? "bg-purple-600 text-white"
                  : "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300"
              }`}
            >
              2. Revisão
            </span>
            {hasResult && (
              <span className="rounded-full bg-white/80 px-3 py-1 font-medium text-gray-700 dark:bg-boxdark/70 dark:text-gray-200">
                {visiblePrescriptionsCount} treinos | {totalExercises} exercícios
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
